var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "750" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [
                  _c("v-icon", [_vm._v("done")]),
                  _vm._v("Finalización de programación\n      ")
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        [
                          _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("h4", [
                              _c("strong", [_vm._v("Hoja de ruta:")]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.form.comprobante2) +
                                  "\n                  "
                              )
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c("v-flex", [
                            _c("h4", [
                              _c("strong", [_vm._v("Fecha de finalización :")]),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.form.fecha_fin) +
                                  "\n                  "
                              )
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("h4", [
                              _c("strong", [_vm._v("Usuario :")]),
                              _vm._v(
                                " " + _vm._s("Personal de recursos humanos")
                              )
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "rgb(80,38,217)", dark: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.descargarDocumento(
                                        _vm.form.ruta
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", [_vm._v("picture_as_pdf")]),
                                  _vm._v(
                                    "\n          Documento de respaldo\n        "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error", loading: _vm.loading },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("close")]),
                      _vm._v("\n          CERRAR\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aef5ca2e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aef5ca2e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacacion_rrhh/dialogs/InformacionProgramacionDelMinisterio.vue
// module id = null
// module chunks = 